import { Line, mixins } from 'vue-chartjs'

export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['options', 'chartData'],
    mounted() {

        this.renderChart(this.chartData, this.options)
    },
    watch: {
        chartData(){
            console.log('updating chart');
            this.$data._chart.update();
        }
    }
}
